import { jsx as o } from "react/jsx-runtime";
import s from "./style.module.less.js";
const n = ({ children: r, className: e }) => /* @__PURE__ */ o("div", { className: `${s.shinyBorderContainer} ${e ?? ""}`, children: r });
export {
  n as MakeMeShiny
};
